import appBar from './appBar.json';
import navigation from './navigation.json';
import organizations from './organizations.json';

export default {
  applicationName: 'Unified Portal',
  appBar,
  navigation,
  organizations,
};
